/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
console.log( 'Hello World! (from create-block-block-image-slider block)' );
/* eslint-enable no-console */

jQuery(document).ready(function($) {
//window.addEventListener('DOMContentLoaded', function() {

    const thisSwiper = [];
	$(".wp-block-africamps-block-image-slider").each(function(i) {
		const sectionId = '#' + ($(this).attr('id'));
		const dynamicSelector = sectionId + " .swiper-container";
        console.log('- dynamicSelector:' + dynamicSelector);
		thisSwiper[i] = new Swiper(dynamicSelector, {
			lazy: true,
            loop: true,
            autoplay: $(this).data('slider-autoplay') === 'enabled' ? {
                delay: 2500,
                disableOnInteraction: false,
            } : false,
            pagination: {
                el: sectionId + " .swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: sectionId + " .swiper-button-next",
                prevEl: sectionId + " .swiper-button-prev",
            },
            paginationClickable: true,
            parallax: true,
            speed: 600	
		});
	});
});